<template>
  <v-dialog v-model="galleryIsActive" width="80%" @close="closeGallery" @keydown.esc="closeGallery">
    <v-carousel v-if="images.length" :cycle="false" height="400" hide-delimiter-background show-arrows-on-hover>
      <v-carousel-item v-for="(item, index) in images" :key="`gallery_image_${index}`">
        <div
          :class="{ 'gallery-item-wrapper--active': images.length }"
          class="gallery-item-wrapper width100 height100 flex-container align-center justify-center"
        >
          <img :src="item.url" class="gallery-item" alt="" />
        </div>
      </v-carousel-item>
    </v-carousel>
  </v-dialog>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    galleryIsActive: false,
  }),
  methods: {
    closeGallery() {
      this.$emit('clearImages')
      this.galleryIsActive = false
    },
  },
  watch: {
    images(val) {
      this.galleryIsActive = !!val.length
    },
  },
}
</script>

<style lang="scss" scoped>
.gallery-item-wrapper {
  transition: all 0.3s;
  background-color: rgba(0, 0, 0, 0);

  &--active {
    background-color: rgba(0, 0, 0, 0.7);
  }
}
.gallery-item {
  max-height: 100%;
  max-width: 100%;
}
</style>
